// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { type State } from 'store/modules';
import { actionCreators as commonActions } from 'store/modules/common';
import CategorySectionList from 'components/categories/CategorySectionList';

type Props = {
  categorySections: any,
  CommonActions: any,
};

class CategorySectionListContainer extends Component<Props> {
  componentDidMount() {
    const { CommonActions } = this.props;
    CommonActions.getCategorySections();
  }

  render() {
    const { categorySections } = this.props;
    return <CategorySectionList sections={categorySections} />;
  }
}

export default connect(
  ({ common }: State) => ({
    categorySections: common.categorySections.data,
  }),
  dispatch => ({
    CommonActions: bindActionCreators(commonActions, dispatch),
  }),
)(CategorySectionListContainer);



// WEBPACK FOOTER //
// ./src/containers/categories/CategorySectionListContainer.js